export default __webpack_public_path__ + "static/media/security_questions_cover.f33e2fc8.svg";